import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={27.507}
    height={25.7}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 23305 21775"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#000}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974336606704">
        <path
          d="M10321 19700h2980c-276 521-976 848-1490 847-558-1-1378-429-1490-847zm-319-1543h3618v319h-3618v-319zm3778-1223H9789c-71-856-1153-1866-1536-2349-2866-3609 430-8370 4503-7482 3599 785 4854 5154 2393 7688-115 118-116 147-215 264-453 540-981 1135-1154 1879zm-7821-5693c0 1507 121 2369 999 3682 1041 1555 1820 1292 1819 3981-2 2629 3832 4133 5579 1479 869-1321 215-2208 684-3306 616-1440 2624-2298 2624-5517 0-3162-2622-5799-5959-5799-2155 0-3884 1218-4885 2776-90 140-212 331-276 469-249 538-585 1462-585 2235zM0 11773c0 343 199 638 532 638h3458c756 0 797-1224-106-1224H585c-311 0-585 275-585 586zM3352 19541c0 275 329 585 585 585 446 0 1126-834 1556-1264 744-743 1710-1403 1120-1998-592-597-1233 356-1971 1094-252 252-466 465-718 718-241 240-572 408-572 865zM16759 6133c0 286 308 585 585 585 431 0 756-462 998-705 275-275 1618-1576 1740-1771 339-537-141-982-503-982-343 0-617 377-812 572l-1436 1437c-241 240-572 408-572 864zM3352 3845c0 456 832 1126 1290 1583l692 692c244 244 746 939 1279 402 473-477-41-920-375-1253L4828 3859c-191-192-513-599-838-599-321 0-638 269-638 585zM11173 706v2820c0 977 1277 977 1277 0V706c0-934-1277-948-1277 0zM16759 17253c0 446 311 603 545 838l1437 1436c199 199 491 599 838 599 470 0 767-522 532-957l-1689-1717c-192-191-681-784-971-784-364 0-692 244-692 585zM19047 11773c0 327 253 638 585 638h3139c703 0 739-1224-53-1224h-2980c-225 0-350 52-469 169-77 75-222 288-222 417z"
          className="fil0"
        />
        <path
          d="M11066 8367c0 1072 1117 299 2372 1246 457 345 411 457 820 457 402 0 1348-702-568-1773-434-243-2624-1074-2624 70z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
